"use client";

import { AdminEntityDirectory } from "@/components/admin.entity-directory";

const AdminOrgsPage = () => {
  return (
    <div className="@container/main flex flex-1 flex-col gap-6 p-4 md:p-8">
      <div>
        <h1 className="text-3xl font-bold">Orgs</h1>
        <p className="text-muted-foreground">
          Browse organizations. Credits and payment methods belong to the organization wallet. Open an org to manage
          projects, capacity allowlist, and members.
        </p>
      </div>

      <AdminEntityDirectory fixedView="orgs" />
    </div>
  );
};

export default AdminOrgsPage;
